import axios from 'axios'
import { useEffect, useState, useRef } from 'react'
import { useTranslation, TFunction } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { CallBackOpenDialog } from '../../control/dialogAlert/withDialog'
import useFormFeedbackStore from '../../stores/useFormFeedbackStore'
import useLoadingStore from '../../stores/useLoadingStore'
import ConfigAPI from '../../constant/ConfigAPI'
import { validateFormatNumberOnly } from '../../util/validate'
import useMapStore from '../../stores/useMapStore'

export interface FormType {
    stable: number
    abnormal: string | null
    antennaType: number
    antennaHeight: string | null
    distanceDoor: string | null
    directionDoor: number
    comments: string | null
}

const validate = async (values: FormType, t: TFunction<'translation'>) => {
    const errors: Partial<any> = {}

    if (!values.stable) {
        errors.stable = `${t('LABEL.TEXT_REQUIRED')}`
    }

    if (values.stable === 2 && !values.abnormal) {
        errors.abnormal = `${t('LABEL.TEXT_REQUIRED')}`
    }

    if (!values.antennaType || values.antennaType === 0) {
        errors.antennaType = `${t('LABEL.TEXT_REQUIRED')}`
    }

    if (values.antennaType === 1 && !values.antennaHeight) {
        errors.antennaHeight = `${t('LABEL.TEXT_REQUIRED')}`
    }

    if (values.antennaType === 2 || values.antennaType === 3) {
        if (!values.antennaHeight) {
            errors.antennaHeight = `${t('LABEL.TEXT_REQUIRED')}`
        }
        if (values.antennaHeight && !validateFormatNumberOnly(values.antennaHeight)) {
            errors.antennaHeight = `${t('LABEL.NUMBER_REQUIRED')}`
        }
        if (!values.distanceDoor) {
            errors.distanceDoor = `${t('LABEL.TEXT_REQUIRED')}`
        }
        if (values.distanceDoor && !validateFormatNumberOnly(values.distanceDoor)) {
            errors.distanceDoor = `${t('LABEL.NUMBER_REQUIRED')}`
        }
    }

    return errors
}

type LookupType = {
    antennaType: LookupResponseType[]
    stable: LookupResponseType[]
    door: LookupResponseType[]
}

const initialValuesFirst = {
    stable: 0,
    abnormal: null,
    antennaType: 0,
    antennaHeight: null,
    distanceDoor: null,
    directionDoor: 0,
    comments: null,
}

type UseFormFeedback = CallBackOpenDialog
const useFormFeedback = (props: UseFormFeedback) => {
    const { openDialog } = props
    const formFeedbackStore = useFormFeedbackStore()
    const loadingStore = useLoadingStore()
    const { t } = useTranslation()
    const history = useHistory()
    const mapStore = useMapStore()

    const valueSubmitted = useRef<FormType>()
    const [initialValues] = useState<FormType>(initialValuesFirst)
    const [openDialogBack, setOpenDialogBack] = useState<boolean>(false)
    const [openDialogSave, setOpenDialogSave] = useState<boolean>(false)

    const [lookups, setLookups] = useState<LookupType>({
        antennaType: [],
        stable: [],
        door: [],
    })

    const callserviceLookup = async () => {
        try {
            loadingStore.setLoading(true)
            const url = `${process.env.REACT_APP_API}/api/feedback/lookup`
            const result = await axios.get(url, ConfigAPI)
            if (result.data) {
                setLookups({
                    antennaType: result.data?.antennaType ?? [],
                    stable: result.data?.stable ?? [],
                    door: result.data?.door ?? [],
                })
            }
        } catch (error) {
            //@ts-ignore
            const errMsg: string = error?.toString()
            if (errMsg) {
                if (errMsg.includes('401')) {
                    //callServiceReLogin('/report-feedback')
                }
            }
        } finally {
            loadingStore.setLoading(false)
        }
    }

    const validates = (values: FormType) => {
        const validation = validate(values, t) || {}
        return validation
    }

    const handleSubmitForm = (values: FormType) => {
        valueSubmitted.current = values
        setOpenDialogSave(true)
        // if (openDialog) {
        //     openDialog({
        //         title: t('ALERT.TITLE.NOTIFY'),
        //         content: t('ALERT.CONTENT.NEED_TO_SAVE'),
        //         displayBtnSave: true,
        //         displayBtnCancel: true,
        //         afterBtnSave: () => {
        //             const reqParams = {
        //                 signalState: lookups.stable.find((item) => item.code === values.stable),
        //                 signalDetail: values.abnormal,
        //                 antennaType: lookups.antennaType.find((item) => item.code === values.antennaType),
        //                 height: values.antennaHeight,
        //                 width: values.distanceDoor,
        //                 door: lookups.door.find((item) => item.code === values.directionDoor),
        //                 otherDetail: values.comments,
        //                 receivingPoint: {
        //                     latitude: formFeedbackStore.stationDetail?.latitude,
        //                     longitude: formFeedbackStore.stationDetail?.longitude,
        //                 },
        //             }
        //             callServiceSend(reqParams)
        //         },
        //     })
        // }
    }

    const callServiceSend = async (param: any) => {
        try {
            loadingStore.setLoading(true)
            const url = `${process.env.REACT_APP_API}/api/feedback/send`
            const result = await axios.post(url, param, ConfigAPI)
            if (result.status === 200) {
                formFeedbackStore.setAlertSuccess(true)
                formFeedbackStore.setIsOpen(false)
                history.push('/')
            }
        } catch (error) {
        } finally {
            loadingStore.setLoading(false)
        }
    }

    const handleClickCancel = () => {
        setOpenDialogBack(true)
        // if (openDialog) {
        //     openDialog({
        //         title: t('ALERT.TITLE.NOTIFY'),
        //         content: t('ALERT.CONTENT.DISCARD_CHANGE'),
        //         displayBtnYes: true,
        //         displayBtnNo: true,
        //         labelBtn: [`${t('BUTTON.STAY')}`, `${t('BUTTON.LEAVE')}`],
        //         afterBtnNo: () => {
        //             formFeedbackStore.setIsOpen(false)
        //             history.push('/')
        //         },
        //     })
        // }
    }

    const handleClickConfirmBack = () => {
        setOpenDialogBack(false)
        formFeedbackStore.setIsOpen(false)
        history.push('/')
    }

    const handleClickCancelBack = () => {
        setOpenDialogBack(false)
    }

    const handleClickConfirmSave = () => {
        const values = valueSubmitted.current as FormType
        const reqParams = {
            signalState: lookups.stable.find((item) => item.code === values.stable),
            signalDetail: values.abnormal,
            antennaType: lookups.antennaType.find((item) => item.code === values.antennaType),
            height: values.antennaHeight,
            width: values.distanceDoor,
            door: lookups.door.find((item) => item.code === values.directionDoor),
            otherDetail: values.comments,
            receivingPoint: {
                latitude: mapStore.selectedLocation?.latitude,
                longitude: mapStore.selectedLocation?.longitude,
            },
        }
        callServiceSend(reqParams)
        setOpenDialogSave(false)
    }

    const handleClickCancelSave = () => {
        setOpenDialogSave(false)
    }

    useEffect(() => {
        const latitude = formFeedbackStore.stationDetail?.latitude
        const longitude = formFeedbackStore.stationDetail?.longitude

        if (latitude && longitude) {
            formFeedbackStore.setIsOpen(true)
            callserviceLookup()
        }
    }, [formFeedbackStore.isOpen])

    return {
        t,
        openDialog: formFeedbackStore.isOpen,
        setOpenDialog: formFeedbackStore.setIsOpen,
        formProps: {
            initialValues,
            validates,
            onSubmitForm: handleSubmitForm,
            onClickCancel: handleClickCancel,
        },
        lookups,
        data: formFeedbackStore.stationDetail,
        dialogAlert: {
            openDialogBack,
            onClickConfirmBack: handleClickConfirmBack,
            onClickCancelBack: handleClickCancelBack,
            openDialogSave,
            onClickConfirmSave: handleClickConfirmSave,
            onClickCancelSave: handleClickCancelSave,
        },
    }
}

export default useFormFeedback
